import { useEffect } from 'react';
export const useResizeOnScreenSizeChange = ({ rowVirtualizer, screenSize, }) => {
    useEffect(() => {
        rowVirtualizer.measure();
    }, [screenSize]);
};
